<template>
  <div>
    <!-- Timeline -->
    <div style="padding-top: 6px">
      <!-- Timeline Phases -->
      <div
        v-for="(phase, index) in phasesArray"
        :key="index"
        class="TimelineRow TimelineHeader"
        :style="{
          backgroundColor: calculateBkColor(phase.Completed, phase.PhaseName),
          width: colWidth,
        }"
        v-show="ShowThis(phase.PhaseName)"
      >
        <span>{{ phase.PhaseName }}</span>
        <span class="fontArrow">
          <font-awesome-icon icon="play" />
        </span>
      </div>
      <!-- /Timeline Phases -->

      <!-- Phase Milestones -->
      <div
        v-for="(phase, idx) in phasesArray"
        :key="`phase${idx}`"
        class="TimelineRow TimelineDetails"
        :style="{ width: colWidth }"
        v-show="ShowThis(phase.PhaseName)"
      >
        <div
          v-for="(detail, d_idx) in phase.EventDetails"
          :key="`event${d_idx}`"
        >
          <div>
            <!-- Milestone Icon -->
            <span class="Rowitem">
              <font-awesome-icon
                icon="check"
                v-if="detail['EventComplete?'] == 1"
                style="color: lightgray"
              />
              <font-awesome-icon
                icon="circle"
                v-if="detail['EventComplete?'] == 0"
                :style="{
                  color: isActiveTask(
                    detail['EventComplete?'],
                    idx,
                    phase.PhaseName,
                    d_idx
                  )
                    ? '#F78F2A'
                    : 'lightgray',
                }"
              />
            </span>
            <!-- /Milestone Icon -->
            <!-- Milestone Text -->
            <span
              :style="{
                color: calculateFontColor(
                  phase.Completed,
                  phase.PhaseName,
                  detail['EventComplete?']
                ),
                fontWeight: isActiveTask(
                  detail['EventComplete?'],
                  idx,
                  phase.PhaseName,
                  d_idx
                )
                  ? 'bold'
                  : 'normal',
                cursor:
                  FormatHover(detail.Event_Hover, detail['EventComplete?']) !=
                  ''
                    ? 'pointer'
                    : 'default',
              }"
              :title="FormatHover(detail.Event_Hover, detail['EventComplete?'])"
              >{{ detail.EventDescription }}</span
            >
            <!-- /Milestone Text -->
          </div>

          <!-- Active Milestone Details -->
          <div
            v-if="
              isActiveTask(
                detail['EventComplete?'],
                idx,
                phase.PhaseName,
                d_idx
              )
            "
            style="padding-left: 28px"
          >
            <!-- Current Milestone Notes -->
            <!-- Active Service (LIVE) -->
            <span v-if="!isObjectEmpty(milestonesData.CurrentMilestoneNotes)">
              <!-- {{milestonesData.CurrentMilestoneNotes[0]['Active Date']}} -->
              <div
                v-for="(value, propertyName, index) in milestonesData
                  .CurrentMilestoneNotes[0]"
                :key="index"
              >
                <div v-if="propertyName != 'Alerts'">
                  {{ propertyName }}: {{ value }}
                </div>
                <div v-else>
                  <div v-for="(alert, alertIndex) in value" :key="alertIndex">
                    <span
                      v-show="alert.AlertDisplayFlag"
                      style="padding-right: 4px"
                    >
                      <font-awesome-icon
                        icon="exclamation-triangle"
                        style="color: #f78f2a"
                      />
                    </span>
                    {{ alert.Message }}
                  </div>
                </div>
              </div>
            </span>
            <!-- /Active Service (LIVE) -->
            <!-- /Current Milestone Notes -->
          </div>
          <!-- /Active Milestone Details -->
        </div>
      </div>
      <!-- /Phase Milestones -->
    </div>
    <!-- /Timeline -->
  </div>
</template>

<script>
export default {
  name: "MileStoneTimeline",
  props: {
    ProductInstanceID: Number,
  },
  data() {
    return {
      milestonesData: {},
      phasesArray: [],
      phaseEvents: [],
      user: this.$auth.user.UserDetails,
      Phase: "",
    };
  },
  computed: {
    colWidth: function () {
      var phaseCount = this.phasesArray.length;
      this.phasesArray.forEach((p) => {
        if (p.PhaseName == "Decom" && this.milestonesData.Phase != "Decom") {
          phaseCount--;
        }
      });
      return (100 / phaseCount).toString() + "%";
    },
  },
  methods: {
    calculateBkColor(IsComplete, Phase) {
      return IsComplete == 1 || Phase == this.milestonesData.Phase
        ? "#006CA5"
        : "gray";
    },
    calculateFontColor(PhaseComplete, Phase, EventComplete) {
      return (PhaseComplete == 1 || Phase == this.milestonesData.Phase) &&
        EventComplete == 0
        ? "black"
        : "lightgray";
    },
    isActiveTask(isComplete, index, phase, innerIndex) {
      return (
        isComplete == 0 &&
        ((innerIndex == 0 && phase == this.milestonesData.Phase) ||
          (innerIndex != 0 &&
            this.phasesArray[index].EventDetails[innerIndex - 1][
              "EventComplete?"
            ] == 1))
      );
    },
    ShowThis(phase) {
      return phase != "Decom" || this.milestonesData.Phase == "Decom";
    },
    dateFormat(d, fmt) {
      return moment.utc(d).format(fmt);
    },
    isObjectEmpty(obj) {
      if (!obj) {
        return true;
      }
      return Object.keys(obj).length === 0;
    },
    FormatHover(arry, IsComplete) {
      var title = "";
      if (arry.length != 0) {
        // if (IsComplete) {
        //   if (arry[0].Actual_Date != null) {
        //     title += "Actual Date: " + this.dateFormat(new Date(arry[0].Actual_Date),'M/DD/YYYY')
        //   }

        // } else {
        //   if (arry[0].Expected_Date != null) {
        //     title +=
        //       "Expected Date: " +
        //       this.dateFormat(new Date(arry[0].Expected_Date), "M/DD/YYYY");
        //   }
        // }

        const entries = Object.entries(arry[0]);
        for (const [key, value] of entries) {
          if (value != null) {
            //title += key + ": " + this.dateFormat(new Date(value),'M/DD/YYYY') + "\n"
            title += key + ": " + value + "\n";
          }
        }
      }
      return title;
    },
  },
  created: function () {
    this.$axios
      .get(
        `https://api.ccr.net/ColoM360/GetMilestones?ProductInstanceID=${this.ProductInstanceID}`
      )
      .then((response) => {
        // response.data.forEach((product) => {
        //   // if (product.Client_Location_Product_Int_RecID == this.ProductID) {
        //   //   this.milestonesData = product;
        //   // }
        //   this.milestonesData = product;
        // });

        this.milestonesData = response.data[0];

        this.milestonesData.Order_Details.forEach((phaseDetails) => {
          this.phasesArray.push({
            PhaseOrder: phaseDetails.PhaseOrder,
            PhaseName: phaseDetails.PhaseName,
            Completed: phaseDetails["PhaseComplete?"],
            EventDetails: phaseDetails.Event_Details,
          });

          if (phaseDetails.PhaseName == this.Phase) {
            this.phaseEvents = phaseDetails.Event_Details;
          }
        });

        this.phasesArray.sort((a, b) => (a.PhaseOrder > b.PhaseOrder ? 1 : -1));
      });
  },
};
</script>

<style lang="scss" scoped>
.timelineContainer {
  padding-left: 10px;
  padding-right: 10px;
}

.TimelineHeader {
  text-align: center;
  color: white;
  border-right: 2px solid white;
  border-left: 2px solid white;
  font-size: 16px;
}
.TimelineDetails {
  vertical-align: top;
}
.TimelineRow {
  display: inline-block;
  padding: 7px;
}
.Rowitem {
  display: inline-block;
  width: 18px;
}
.fontArrow {
  color: white;
  float: right;
}
</style>